import type { LignePreparation, ScanPreparationPayload } from "@/types/domain";

const nettoyerCle = (valeur: string) => valeur.replace(/[^A-Za-z0-9_-]/g, "-");

export function creerCleScan(
  ligneId: string,
  horodatage = Date.now(),
  alea = Math.random().toString(36).slice(2, 10),
): string {
  return `PICK:${nettoyerCle(ligneId)}:${horodatage}:${nettoyerCle(alea)}`;
}

export function construireScan(
  ligne: LignePreparation,
  identifiant: string,
  quantite: number,
  idempotencyKey: string,
): ScanPreparationPayload {
  const code = identifiant.trim();
  const restant = ligne.quantite_attendue - ligne.quantite_preparee;
  if (!code) throw new Error("Scannez un identifiant produit.");
  if (!Number.isInteger(quantite) || quantite <= 0)
    throw new Error("La quantité doit être un entier positif.");
  if (quantite > restant)
    throw new Error(`La quantité dépasse le restant à préparer (${restant}).`);
  return {
    ligne_preparation_id: ligne.id,
    identifiant: code,
    quantite,
    idempotency_key: idempotencyKey,
  };
}

export async function executerScan<T>(
  payload: ScanPreparationPayload,
  envoyer: (payload: ScanPreparationPayload) => Promise<T>,
): Promise<T> {
  // Aucun fallback local : une indisponibilité backend échoue fermée.
  return envoyer(payload);
}

